import React from 'react';
import Section from './Section';

interface ChatCtaProps {
  children: React.ReactNode;
  // eslint-disable-next-line no-unused-vars
  onClick: (event: React.MouseEvent | React.KeyboardEvent) => void;
  className?: string;
}

const ChatCta = function ({ children, onClick, className = '' }: ChatCtaProps) {
  return (
    <Section aria-hidden="true" tabIndex={-1}>
      <div
        role="button"
        className={className}
        onClick={onClick}
        onKeyPress={onClick}
        tabIndex={0}
      >
        <span>{children}</span>
      </div>
    </Section>
  );
};

export default ChatCta;
